import { registerPlugin } from "@capacitor/core";

export type AddCalendarEventAction =
  | "saved"
  | "cancelled"
  | "deleted"
  | "unknown";

export interface AddCalendarEventOptions {
  title: string;
  /** ISO-8601 datetime */
  startDate: string;
  /** ISO-8601 datetime */
  endDate: string;
  notes?: string;
  url?: string;
  /** Minutes before start for alarm. Default 60 on native. */
  reminderMinutesBefore?: number;
}

export interface AddCalendarEventResult {
  action: AddCalendarEventAction;
}

export interface BileniaCalendarPlugin {
  addCalendarEvent(
    options: AddCalendarEventOptions,
  ): Promise<AddCalendarEventResult>;
}

/** Native iOS only — registered in BridgeViewController. */
export const BileniaCalendar = registerPlugin<BileniaCalendarPlugin>(
  "BileniaCalendar",
);
